<template>
  <div class="min-h-screen flex flex-col items-center justify-center text-center">
    <div>
      <ProgressSpinner stroke-width="4" />
      <p>Signing in...</p>
    </div>
  </div>
</template>
<script setup lang="ts">
import ProgressSpinner from "primevue/progressspinner";

definePage({
  name: 'auth-callback',
  meta: {
    title: 'Signing in...',
    public: false,
  },
})
</script>
